import React from 'react';
import { Bike } from 'lucide-react';
export function Footer() {
  return <footer className="py-16 px-4 bg-slate-950 text-center" role="contentinfo" data-id="element-50">
      <div className="max-w-3xl mx-auto" data-id="element-51">
        <Bike className="w-8 h-8 text-amber-500 mx-auto mb-6" strokeWidth={2} aria-hidden="true" data-id="element-52" />
        <p className="text-amber-500 italic font-medium" data-id="element-53">
          by <span className="font-bold" data-id="element-54">PROTORRENDA</span> — Para el ciclista
          amateur argentino que entrena en serio.
        </p>
      </div>
    </footer>;
}